import React from 'react';
import { Spin } from 'antd';
import PropTypes from 'prop-types';
import { LoadingOutlined } from '@ant-design/icons';

const Icon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

const Loading = (props) => {
  const { align, cover, show } = props;
  return (
    show && (
      <div
        className={`loading text-${align} cover-${cover}`}
        style={{ zIndex: 99 }}>
        <Spin indicator={Icon} />
      </div>
    )
  );
};

Loading.propTypes = {
  size: PropTypes.string,
  cover: PropTypes.string,
};

Loading.defaultProps = {
  align: 'center',
  cover: 'inline',
  show: false,
};

export default Loading;
